import { render, staticRenderFns } from "./MrpaEnableTrusteeForeignOrganization.vue?vue&type=template&id=7a829f28&"
import script from "./MrpaEnableTrusteeForeignOrganization.vue?vue&type=script&lang=js&"
export * from "./MrpaEnableTrusteeForeignOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports